// src/types/termos.ts
// Tipos do contrato de aceite dos TERMOS DE USO (issue #6), alinhado ao backend
// entregue na #9 do `api-blueltSystem`. O gate NÃO roda no login: a primeira
// request autenticada a rota protegida retorna 403 com `reason=termos_pendente`
// enquanto a versão vigente não for aceita.

// `reason` do 403 que sinaliza termos pendentes de aceite. Detecção é por este
// campo (nunca pela string da mensagem, que é humana e mutável).
export const TERMOS_PENDENTE_REASON = 'termos_pendente';

// Corpo do 403 de termos pendentes (snake_case — espelha o backend), consumido
// pelo interceptor de `api.ts` para abrir o modal de aceite.
export interface TermosPendenteBody {
  error?: string;
  reason?: string;
  versao_atual?: string; // versão a ser aceita — DINÂMICA, nunca hardcode
  code?: string;
}

// Resposta 200 de GET /v1/pessoas/usuarios/termos-vigente (rota isenta do gate).
// `texto` vem do banco em markdown — renderizado com react-markdown (sem HTML bruto).
export interface TermosVigente {
  versao: string;
  texto: string;
  dataPublicacao?: string;
}

// Resposta 200 de PUT /v1/pessoas/usuarios/aceitar-termos (rota isenta do gate).
export interface AceitarTermosResponse {
  message: string;
  versao: string;
}
